<template>
  <div>
    <img v-if="pc" :src="$t('services.img')" width="100%" />
    <img v-else :src="$t('services.imgm')" width="100%" />
    <div class="mw1200" :class="{mlr: !pc}" style="margin: 60px auto">
      <div class="h1_p">
        <h1 :class="{f36: !pc}">{{$t('menu.services')}}</h1>
        <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'30px'}" v-html="$t('services.p')"></p>
      </div>
      <div v-if="pc" style="display: flex;justify-content: space-between;flex-wrap: wrap">
        <div v-for="(item, index) in $t('services.list')" :key="index" style="margin-bottom: 60px;width: 30%">
          <img class="img_trans" :src="item.img" width="100%" />
          <div style="font-size: 20px;color: #7F1F20;margin: 20px 0 5px 0">{{item.h1}}</div>
          <div style="font-size: 15px;line-height: 23px">{{item.p}}</div>
        </div>
      </div>
      <div v-else style="display: flex;justify-content: space-between;flex-wrap: wrap">
        <div v-for="(item, index) in $t('services.list')" :key="index" style="margin-bottom: 60px;width: 48%">
          <img class="img_trans" :src="item.img" width="100%" />
          <div style="font-size: 24px;color: #7F1F20;margin: 20px 0 5px 0">{{item.h1}}</div>
          <div style="line-height: 30px;font-size: 20px">{{item.p}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['pc'])
  }
}
</script>
